export class ExportContentType {
    public static readonly ExcelContentType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
    public static readonly CsvContentType = 'text/csv';
}